/**
 * Protected Route Component
 * Requires authentication to access
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/shared/constants';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Protected route wrapper
 * Redirects to login if not authenticated
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  // TODO: Replace with actual auth check from auth context/store
  const isAuthenticated = false;

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return <>{children}</>;
}
